export default __webpack_public_path__ + "static/media/incident_management_impression.27c7b993.png";